import axios from "axios";
import { BaseUrl } from "../helper/BaseUrl";
import { clearAuthSession, getAuthToken } from "./AuthSession";

const ApiRequest = async (method, endpoint, payload = {}) => {
  const headers = {
    headers: {
      "x-access-token": getAuthToken(),
    },
  };
  try {
    let response = null;
    switch (method) {
      case "POST":
        response = await axios.post(BaseUrl + endpoint, payload, headers);
        break;

      case "GET":
        response = await axios.get(BaseUrl + endpoint, headers);
        break;

      // case "PUT":
      //   response = await axios.put(BaseUrl + endpoint, payload, headers);
      //   break;

      case "DELETE":
        response = await axios.delete(BaseUrl + endpoint, payload, headers);
        break;

      default:
        throw new Error(`Invalid method: ${method}`);
    }
    return response.data;
  } catch (error) {
    const status = error.response?.status;
    if (status === 401 || status === 403) {
      clearAuthSession();
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    throw error;
  }
};

export default ApiRequest;
